module.exports = __webpack_public_path__ + "img/fossil2Img1.4bb5657f.jpg";